/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { EventEmitter, ViewContainerRef } from '@angular/core';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { FilterComponentFactory } from '@irian-ro/table-column-filter';
import { DateTableFilterComponent } from './date-table-filter/date-table-filter.component';

export interface InputOptions {
  props?: {
    value: string | null;
    name: string;
    placeholder?: string;
  };
  filterMatchMode?: string;
  filterChangeEvent?: EventEmitter<FilterMetadata>;
}

export const calendarFactory: FilterComponentFactory<DateTableFilterComponent> = {
  createInstance: (container: ViewContainerRef) => {
    return container.createComponent<DateTableFilterComponent>(DateTableFilterComponent).instance;
  },

  bindProps: (instance: DateTableFilterComponent, options?: InputOptions) => {
    if (options?.props?.value) {
      instance.value = options.props?.value;
    }

    instance.style = { width: "100%" };
    instance.placeholder = options?.props?.placeholder ?? '';
    instance.name = options?.props?.name ?? 'calendar';
  },

  subscribeToChanges: (instance: DateTableFilterComponent, options?: InputOptions) => {
    instance.onFilter.subscribe((value: string) => {
      if (options?.filterChangeEvent) {
        options?.filterChangeEvent.emit({
          value: value,
          matchMode: options?.filterMatchMode
        });
      }
    });
  }
};
